// extracted by mini-css-extract-plugin
export default {"primary":"#284378","secondary":"#007acc","tertiary":"#4dbfa3","light":"#ffffff","dark":"#284378","formSucces":"#2ecc71","formWarning":"#d35400","formError":"#c0392b"};